import { LoadingSpinner, Stack } from '@adc/parallax-component-library';

type Props = {
  testID: string;
};

export const ContentLoader = ({ testID }: Props) => (
  <Stack
    testID={testID}
    position="absolute"
    top={0}
    left={0}
    right={0}
    bottom={0}
    alignItems="center"
    justifyContent="center"
    // @ts-expect-error Using custom color
    backgroundColor="rgba(255, 255, 255, 0.8)"
    zIndex={1000}
    borderRadius="$2"
  >
    <LoadingSpinner />
  </Stack>
);
